import React from "react";
import { Button, Space, Tag } from "antd";
import { formatDate } from "../../../../utility/commonConstant";

const levelStyles = {
  intermediate: {
    color: "var(--color-success)",
    background: "var(--background-success)",
    borderColor: "var(--border-success)",
    label: "INTERMEDIATE",
  },
  professional: {
    color: "var(--color-primary-100)",
    background: "var(--color-primary-05)",
    borderColor: "var(--color-secondary-30)",
    label: "PROFESSIONAL",
  },
  default: {
    color: "var(--blue)",
    background: "var(--light-blue)",
    borderColor: "var(--blue-80)",
    label: "BEGINNER",
  },
};

export const getCoursesColumns = (onViewDetails) => [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    align: "left",
    width: 300,
    onCell: () => ({ className: "text-left pl-12" }),
    render: (title) => <Space>{title}</Space>,
  },
  {
    title: "Level",
    dataIndex: "level",
    key: "level",
    align: "center",
    render: (level) => {
      if (!level) return <Tag color="default">Unknown</Tag>;
      const styles = levelStyles[level.toLowerCase()] ?? levelStyles.default;
      return (
        <Tag
          className="w-[110px] text-center !px-4 !py-[10px] !rounded-[10px] !border !font-medium"
          style={{
            color: styles.color,
            borderColor: styles.borderColor,
            backgroundColor: styles.background,
          }}
        >
          {styles.label}
        </Tag>
      );
    },
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    key: "createdAt",
    align: "center",
    render: (date) => formatDate(date, "DD-MMM-YYYY"),
  },
  {
    title: <div className="pr-12 text-right">Action</div>,
    key: "action",
    align: "right",
    width: 100,
    onCell: () => ({ className: "text-right pr-12" }),
    render: (_, record) => (
      <Button
        type="link"
        className="!text-[rgba(145,14,17,1)] underline"
        onClick={() => onViewDetails(record.courseId, record.title)}
      >
        View Details
      </Button>
    ),

  },
];